import { PackageCheckIcon } from './PackageCheckIcon';

/**
 * author: Hans Böhm
 * id B1DB46BF-FA20-40F6-88CD-A5B06CB3E488
 * name package-check
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-check.svg
 * tags
 */
export const PackageDeliveredIcon = PackageCheckIcon;
export default PackageDeliveredIcon